import React from "react";
import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import { Box, Button } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { useHistory } from "react-router";

import WGEventsContainer from "@jumbo/Dashboards/WordGameEvents";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.wordGameEvents"} />, isActive: true },
];

const WordGameEvents = () => {
  const history = useHistory();

  return (
    <PageContainer
      heading={<IntlMessages id="pages.wordGameEvents" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <Box
            marginBottom={"10px"}
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <IntlMessages id="pages.wordGameEvents.description" />
            <Button
              variant="contained"
              color="primary"
              startIcon={<Add />}
              onClick={() => history.push("/wordGame/createEvent")}
              style={{ marginRight: 14 }}
            >
              ایجاد رویداد
            </Button>
          </Box>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <WGEventsContainer />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default WordGameEvents;
